import { render, staticRenderFns } from "./MessageThread.vue?vue&type=template&id=6ef2775e&scoped=true&"
import script from "./MessageThread.vue?vue&type=script&lang=js&"
export * from "./MessageThread.vue?vue&type=script&lang=js&"
import style0 from "./MessageThread.vue?vue&type=style&index=0&id=6ef2775e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ef2775e",
  null
  
)

export default component.exports